import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

// Medical checklist screen
import { MedicalChecklistScreen } from '../../screens/checklists/MedicalChecklistScreen';

// Caregiver screens
import { CaregiverIntroScreen } from '../../screens/tasks/medical/caregiver/CaregiverIntroScreen';
import { CaregiverInputScreen } from '../../screens/tasks/medical/caregiver/CaregiverInputScreen';
import { CaregiverDataScreen } from '../../screens/tasks/medical/caregiver/CaregiverDataScreen';
import { CaregiverLockUnlockScreen } from '../../screens/tasks/medical/caregiver/CaregiverLockUnlockScreen';
import { CaregiverLockedScreen } from '../../screens/tasks/medical/caregiver/CaregiverLockedScreen';
import { CaregiverUnlockedScreen } from '../../screens/tasks/medical/caregiver/CaregiverUnlockedScreen';

// Medical Equipment screens
import { MedicalEquipmentIntroScreen } from '../../screens/tasks/medical/medicalEquipment/MedicalEquipmentIntroScreen';
import { MedicalEquipmentInputScreen } from '../../screens/tasks/medical/medicalEquipment/MedicalEquipmentInputScreen';
import { MedicalEquipmentDataScreen } from '../../screens/tasks/medical/medicalEquipment/MedicalEquipmentDataScreen';
import { MedicalEquipmentLockUnlockScreen } from '../../screens/tasks/medical/medicalEquipment/MedicalEquipmentLockUnlockScreen';
import { MedicalEquipmentLockedScreen } from '../../screens/tasks/medical/medicalEquipment/MedicalEquipmentLockedScreen';
import { MedicalEquipmentUnlockedScreen } from '../../screens/tasks/medical/medicalEquipment/MedicalEquipmentUnlockedScreen';

// Medical History screens
import { MedicalHistoryIntroScreen } from '../../screens/tasks/medical/medicalHistory/MedicalHistoryIntroScreen';
import { MedicalHistoryInputScreen } from '../../screens/tasks/medical/medicalHistory/MedicalHistoryInputScreen';
import { MedicalHistoryDataScreen } from '../../screens/tasks/medical/medicalHistory/MedicalHistoryDataScreen';
import { MedicalHistoryLockUnlockScreen } from '../../screens/tasks/medical/medicalHistory/MedicalHistoryLockUnlockScreen';
import { MedicalHistoryLockedScreen } from '../../screens/tasks/medical/medicalHistory/MedicalHistoryLockedScreen';
import { MedicalHistoryUnlockedScreen } from '../../screens/tasks/medical/medicalHistory/MedicalHistoryUnlockedScreen';

// Medications screens
import { MedicationsIntroScreen } from '../../screens/tasks/medical/medication/MedicationsIntroScreen';
import { MedicationsInputScreen } from '../../screens/tasks/medical/medication/MedicationsInputScreen';
import { MedicationsDataScreen } from '../../screens/tasks/medical/medication/MedicationsDataScreen';
import { MedicationsLockUnlockScreen } from '../../screens/tasks/medical/medication/MedicationsLockUnlockScreen';
import { MedicationsLockedScreen } from '../../screens/tasks/medical/medication/MedicationsLockedScreen';
import { MedicationsUnlockedScreen } from '../../screens/tasks/medical/medication/MedicationsUnlockedScreen';

// Organ Donor screens
import { OrganDonorIntroScreen } from '../../screens/tasks/medical/organDonor/OrganDonorIntroScreen';
import { OrganDonorIntroScreen2 } from '../../screens/tasks/medical/organDonor/OrganDonorIntroScreen2';
import { OrganDonorIntroScreen3 } from '../../screens/tasks/medical/organDonor/OrganDonorIntroScreen3';
import { OrganDonorIntroScreen4 } from '../../screens/tasks/medical/organDonor/OrganDonorIntroScreen4';
import { OrganDonorInputScreen } from '../../screens/tasks/medical/organDonor/OrganDonorInputScreen';
import { OrganDonorDataScreen } from '../../screens/tasks/medical/organDonor/OrganDonorDataScreen';
import { OrganDonorLockUnlockScreen } from '../../screens/tasks/medical/organDonor/OrganDonorLockUnlockScreen';
import { OrganDonorLockedScreen } from '../../screens/tasks/medical/organDonor/OrganDonorLockedScreen';
import { OrganDonorUnlockedScreen } from '../../screens/tasks/medical/organDonor/OrganDonorUnlockedScreen';

// Primary Physician screens
import { PrimaryPhysicianIntroScreen } from '../../screens/tasks/medical/primaryPhysician/PrimaryPhysicianIntroScreen';
import { PrimaryPhysicianInputScreen } from '../../screens/tasks/medical/primaryPhysician/PrimaryPhysicianInputScreen';
import { PrimaryPhysicianDataScreen } from '../../screens/tasks/medical/primaryPhysician/PrimaryPhysicianDataScreen';
import { PrimaryPhysicianLockUnlockScreen } from '../../screens/tasks/medical/primaryPhysician/PrimaryPhysicianLockUnlockScreen';
import { PrimaryPhysicianLockedScreen } from '../../screens/tasks/medical/primaryPhysician/PrimaryPhysicianLockedScreen';
import { PrimaryPhysicianUnlockedScreen } from '../../screens/tasks/medical/primaryPhysician/PrimaryPhysicianUnlockedScreen';

// Specialty Physician screens
import { SpecialtyPhysicianIntroScreen } from '../../screens/tasks/medical/specialtyPhysician/SpecialtyPhysicianIntroScreen';
import { SpecialtyPhysicianInputScreen } from '../../screens/tasks/medical/specialtyPhysician/SpecialtyPhysicianInputScreen';
import { SpecialtyPhysicianDataScreen } from '../../screens/tasks/medical/specialtyPhysician/SpecialtyPhysicianDataScreen';
import { SpecialtyPhysicianLockUnlockScreen } from '../../screens/tasks/medical/specialtyPhysician/SpecialtyPhysicianLockUnlockScreen';
import { SpecialtyPhysicianLockedScreen } from '../../screens/tasks/medical/specialtyPhysician/SpecialtyPhysicianLockedScreen';
import { SpecialtyPhysicianUnlockedScreen } from '../../screens/tasks/medical/specialtyPhysician/SpecialtyPhysicianUnlockedScreen';

// Treatments screens
import { TreatmentsIntroScreen } from '../../screens/tasks/medical/treatment/TreatmentsIntroScreen';
import { TreatmentsInputScreen } from '../../screens/tasks/medical/treatment/TreatmentsInputScreen';
import { TreatmentsDataScreen } from '../../screens/tasks/medical/treatment/TreatmentsDataScreen';
import { TreatmentsLockUnlockScreen } from '../../screens/tasks/medical/treatment/TreatmentsLockUnlockScreen';
import { TreatmentsLockedScreen } from '../../screens/tasks/medical/treatment/TreatmentsLockedScreen';
import { TreatmentsUnlockedScreen } from '../../screens/tasks/medical/treatment/TreatmentsUnlockedScreen';

const Stack = createNativeStackNavigator();

const MedicalStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      {/* Main Medical Checklist */}
      <Stack.Screen name="MedicalChecklist" component={MedicalChecklistScreen} />
      
      {/* Caregiver Screens */}
      <Stack.Screen name="CaregiverIntro" component={CaregiverIntroScreen} />
      <Stack.Screen name="CaregiverInput" component={CaregiverInputScreen} />
      <Stack.Screen name="CaregiverData" component={CaregiverDataScreen} />
      <Stack.Screen name="CaregiverLockUnlock" component={CaregiverLockUnlockScreen} />
      <Stack.Screen name="CaregiverLocked" component={CaregiverLockedScreen} />
      <Stack.Screen name="CaregiverUnlocked" component={CaregiverUnlockedScreen} />
      
      {/* Medical Equipment Screens */}
      <Stack.Screen name="MedicalEquipmentIntro" component={MedicalEquipmentIntroScreen} />
      <Stack.Screen name="MedicalEquipmentInput" component={MedicalEquipmentInputScreen} />
      <Stack.Screen name="MedicalEquipmentData" component={MedicalEquipmentDataScreen} />
      <Stack.Screen name="MedicalEquipmentLockUnlock" component={MedicalEquipmentLockUnlockScreen} />
      <Stack.Screen name="MedicalEquipmentLocked" component={MedicalEquipmentLockedScreen} />
      <Stack.Screen name="MedicalEquipmentUnlocked" component={MedicalEquipmentUnlockedScreen} />
      
      {/* Medical History Screens */}
      <Stack.Screen name="MedicalHistoryIntro" component={MedicalHistoryIntroScreen} />
      <Stack.Screen name="MedicalHistoryInput" component={MedicalHistoryInputScreen} />
      <Stack.Screen name="MedicalHistoryData" component={MedicalHistoryDataScreen} />
      <Stack.Screen name="MedicalHistoryLockUnlock" component={MedicalHistoryLockUnlockScreen} />
      <Stack.Screen name="MedicalHistoryLocked" component={MedicalHistoryLockedScreen} />
      <Stack.Screen name="MedicalHistoryUnlocked" component={MedicalHistoryUnlockedScreen} />
      
      {/* Medications Screens */}
      <Stack.Screen name="MedicationsIntro" component={MedicationsIntroScreen} />
      <Stack.Screen name="MedicationsInput" component={MedicationsInputScreen} />
      <Stack.Screen name="MedicationsData" component={MedicationsDataScreen} />
      <Stack.Screen name="MedicationsLockUnlock" component={MedicationsLockUnlockScreen} />
      <Stack.Screen name="MedicationsLocked" component={MedicationsLockedScreen} />
      <Stack.Screen name="MedicationsUnlocked" component={MedicationsUnlockedScreen} />
      
      {/* Organ Donor Screens */}
      <Stack.Screen name="OrganDonorIntro" component={OrganDonorIntroScreen} />
      <Stack.Screen name="OrganDonorIntro2" component={OrganDonorIntroScreen2} />
      <Stack.Screen name="OrganDonorIntro3" component={OrganDonorIntroScreen3} />
      <Stack.Screen name="OrganDonorIntro4" component={OrganDonorIntroScreen4} />
      <Stack.Screen name="OrganDonorInput" component={OrganDonorInputScreen} />
      <Stack.Screen name="OrganDonorData" component={OrganDonorDataScreen} />
      <Stack.Screen name="OrganDonorLockUnlock" component={OrganDonorLockUnlockScreen} />
      <Stack.Screen name="OrganDonorLocked" component={OrganDonorLockedScreen} />
      <Stack.Screen name="OrganDonorUnlocked" component={OrganDonorUnlockedScreen} />
      
      {/* Primary Physician Screens */}
      <Stack.Screen name="PrimaryPhysicianIntro" component={PrimaryPhysicianIntroScreen} />
      <Stack.Screen name="PrimaryPhysicianInput" component={PrimaryPhysicianInputScreen} />
      <Stack.Screen name="PrimaryPhysicianData" component={PrimaryPhysicianDataScreen} />
      <Stack.Screen name="PrimaryPhysicianLockUnlock" component={PrimaryPhysicianLockUnlockScreen} />
      <Stack.Screen name="PrimaryPhysicianLocked" component={PrimaryPhysicianLockedScreen} />
      <Stack.Screen name="PrimaryPhysicianUnlocked" component={PrimaryPhysicianUnlockedScreen} />
      
      {/* Specialty Physician Screens */}
      <Stack.Screen name="SpecialtyPhysicianIntro" component={SpecialtyPhysicianIntroScreen} />
      <Stack.Screen name="SpecialtyPhysicianInput" component={SpecialtyPhysicianInputScreen} />
      <Stack.Screen name="SpecialtyPhysicianData" component={SpecialtyPhysicianDataScreen} />
      <Stack.Screen name="SpecialtyPhysicianLockUnlock" component={SpecialtyPhysicianLockUnlockScreen} />
      <Stack.Screen name="SpecialtyPhysicianLocked" component={SpecialtyPhysicianLockedScreen} />
      <Stack.Screen name="SpecialtyPhysicianUnlocked" component={SpecialtyPhysicianUnlockedScreen} />
      
      {/* Treatments Screens */}
      <Stack.Screen name="TreatmentsIntro" component={TreatmentsIntroScreen} />
      <Stack.Screen name="TreatmentsInput" component={TreatmentsInputScreen} />
      <Stack.Screen name="TreatmentsData" component={TreatmentsDataScreen} />
      <Stack.Screen name="TreatmentsLockUnlock" component={TreatmentsLockUnlockScreen} />
      <Stack.Screen name="TreatmentsLocked" component={TreatmentsLockedScreen} />
      <Stack.Screen name="TreatmentsUnlocked" component={TreatmentsUnlockedScreen} />
    </Stack.Navigator>
  );
};

export default MedicalStackNavigator;